var $7d5ecf37dce62f41$exports = {};
$7d5ecf37dce62f41$exports = {
    "valid": `Platn\xe9`
};


export {$7d5ecf37dce62f41$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
